import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
declare var $: any;


@Component({
  templateUrl: './registerconfirmation.component.html'
})
export class RegisterConfirmationComponent {
  
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/register/registerconfirmation.component.ts